import { createStore } from './createStore.js';

/** High score + the catch log for the hidden pinball table (#/pinball). */
export const pinball = createStore('pdx.pinball', {
  best: 0,
  caught: [],
  sound: true,
  haptics: true,
});

export function recordPinball(score) {
  if (score > pinball.get().best) pinball.set((s) => ({ ...s, best: score }));
}

/** Log a Pokémon "caught" on the table (most recent first, de-duped, capped). */
export function recordCatch(mon) {
  pinball.set((s) => {
    const caught = [mon, ...s.caught.filter((m) => m.id !== mon.id)].slice(0, 24);
    return { ...s, caught };
  });
}

export function togglePinballSound() {
  pinball.set((s) => ({ ...s, sound: !s.sound }));
}

export function togglePinballHaptics() {
  pinball.set((s) => ({ ...s, haptics: !s.haptics }));
}
